import React from 'react';
import PropTypes from 'prop-types';
import { Title, Body } from '@vds/typography';

import { Margin } from '../../../common/styles';
import { HeaderContainer } from './NBS.styles';

const NBSHeader = (props) => {
  const nbsVo = props.data || {};

  const nextMonthCharge = nbsVo && nbsVo?.monthlyTotalsInfo && nbsVo?.monthlyTotalsInfo.nextMonthCharge;
  const accountNumber = nbsVo && nbsVo?.accountLevelChargesVo && nbsVo?.accountLevelChargesVo.accountNumber;
  const typeOfTransaction =
    nbsVo && nbsVo.nbsIndicators && nbsVo.nbsIndicators.oneMessageTransactionType && nbsVo.nbsIndicators.typeOfTransaction.trim().toUpperCase();

  return (
    <div data-testid="NBSHeader">
      <HeaderContainer>
        <Margin bottom="40px" top="10px">
          <Title size="large" primitive="h2" bold>
            {typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? props.header_prospect : props.header_1} {`$${nextMonthCharge}`}
          </Title>
          <Margin top="20px">
            <Body size="large" primitive="p">
              {typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? props.Prospect_header_description : props.Default_header}
            </Body>
          </Margin>
          {typeOfTransaction !== 'Y' && (
            <Margin top="12px">
              <Body size="large" primitive="p">
                Account {`#${accountNumber}`}
              </Body>
            </Margin>
          )}
        </Margin>
      </HeaderContainer>
    </div>
  );
};

NBSHeader.defaultProps = {
  header_1: 'Your next bill estimate is ',
  header_prospect: 'Your first bill estimate is ',
  Default_header: 'Thank you for being a Verizon Wireless customer.  Below are the estimated charges and credits for your next bill.',
  Prospect_header_description:
    "Your first bill is usually higher due to one-time costs associated with becoming a customer. You're also charged for next month's plan because you're billed a month in advance.",
};

NBSHeader.propTypes = {
  data: PropTypes.object,
  header_1: PropTypes.string,
  Default_header: PropTypes.string,
  Prospect_header_description: PropTypes.string,
  header_prospect: PropTypes.string,
};

export default React.memo(NBSHeader);
